import React, { useState, useEffect, useCallback } from 'react';
import { Text, Modal } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import GoogleMap from '../GoogleMap';
import { POLYGON_LAYER_STYLE, EGRESS_ACTIVE } from './constants';
import { initialState, calculateBoundsCenter } from './utils';

const ViewModal = ({ isOpened, onClose, psap }) => {
  const [mapLayers, setMapLayers] = useState(initialState.mapLayers);
  const [map, setMap] = useState(initialState.map);

  const initPolygonLayers = useCallback(() => {
    const polygonLayer = new window.google.maps.Data({ map });
    const jurisdiction = psap.jurisdictions.find(
      juris => juris.egress_status === EGRESS_ACTIVE,
    );
    if (jurisdiction) {
      const { exact_polygon: exactPolygon, expanded_polygon: boundingBox } =
        jurisdiction;

      const polygon = exactPolygon ? exactPolygon : boundingBox;

      polygonLayer.addGeoJson(polygon);
      polygonLayer.setStyle(POLYGON_LAYER_STYLE);
      setMapLayers({ ...mapLayers, ...{ polygon: polygonLayer } });
    }
  }, [map, mapLayers, psap]);

  useEffect(() => {
    if (map) {
      initPolygonLayers();
    }
  }, [map, initPolygonLayers]);

  const centerMap = useCallback(() => {
    const bounds = new window.google.maps.LatLngBounds();
    mapLayers.polygon.forEach(function (feature) {
      feature.getGeometry().forEachLatLng(function (latlng) {
        bounds.extend(latlng);
      });
    });
    map.fitBounds(bounds);
  }, [map, mapLayers]);

  useEffect(() => {
    if (mapLayers.polygon) {
      centerMap();
    }
  }, [mapLayers, centerMap]);

  const handleMapLoad = map => {
    setMap(map);
  };

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={525}
      id="modal-view-jurisdiction-details"
      padding="40px 14px"
    >
      <>
        <ModalHeader onClose={onClose} maxHeight="100%">
          <Text
            size="header"
            fontWeight="semibold"
            color="secondaryText"
            mb={15}
          >
            Your Jurisdictional Boundary
          </Text>
        </ModalHeader>
        <ModalBody noFooter>
          <GoogleMap
            id="admin-config-view-coverage-map"
            style={{
              width: '100%',
              height: 450,
            }}
            onMapReady={handleMapLoad}
            options={{
              zoom: 3,
              center: calculateBoundsCenter({
                north: 48.999968,
                south: 23.634763,
                east: -65.524514,
                west: -125.979106,
              }),
              clickableIcons: false,
            }}
          />
        </ModalBody>
      </>
    </Modal>
  );
};

export default ViewModal;
